<template>
  <div class="after_order">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
      >
        <afterOrderItem v-for="(item,index) in list" :key="index" :item="item" />
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import afterOrderItem from "./components/afterOrderItem";
import http from "@/utils/axios";
import Util from "@/utils/common";
export default {
  data() {
    return { 
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNum: 1,
      error: false
    };
  },
  methods: {
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }
      http({
        url: "/order/app/newafter/page",
        method: "post",
        parmes: {
          pageNum: this.pageNum,
          pageSize: 20
        }
      })
        .then(rps => {
          if (rps.code == 200) {
            this.error = false;
            this.loading = false;
            if (rps.data.list.length === 0) {
              this.finished = true;
            } else {
              this.finished = false;
              this.pageNum++;
            }
            rps.data.list.forEach((item) => {
              item.IS_GOODS = item.orderContentType === 1 // 商品订单
              item.IS_COUPON = item.orderContentType === 2 // 优惠订单
              item.isCoupon = item.IS_COUPON && item.contentCouponType === 1 // 优惠券
              item.isCouponPackage = item.IS_COUPON && item.contentCouponType == 2 // 券包
            });
            this.list = this.list.concat(rps.data.list);
            console.log(this.list)
          }
        })
        .catch(err => {
          this.error = true;
          this.loading = false;
        });
    },
    onRefresh() {
      setTimeout(() => {
        this.pageNum = 1;
        this.finished = false;
        this.loading = true;
        this.onLoad();
      }, 1000);
    }
  },
  created(){
    this.$loading.hide();
    Util.nativeMethod({tm:'4000102',tp:{pageType_pvar:'售后'}})
    Util.nativeMethod({tm:'4000102',tp:{pageName_pvar:document.title}})
  },
  components: { afterOrderItem },
};
</script>
<style lang="less" scoped>
.after_order{
  // background: #F7F7F7;
}
</style>